export default {"src":"/_next/static/media/bitcoinLogo2.625bab8b.svg","height":48,"width":35};